export enum ShowProgramDetails {
  ALL = "all",
  NONE = "none",
  ONLY = "only",
  HIDE_ONLY = "hide only",
}
